import Image from '../../../common/microfrontend/react/Image'
import usePath from './use-path'
export default Image(usePath)
